import React from 'react'
import { Helmet } from 'react-helmet'
import LiveTemplateDefault from 'src/components/template/live'
import { networkLogos } from 'src/constants'
import { createVideoStructuredData } from 'src/modules/utils/videoStructuredData'

export default (props) => {
  // VideoObject structured data
  const videoStructuredData = createVideoStructuredData({
    networkName: 'The Weather Channel',
    callsign: 'WEATHHD',
    logoUrl: networkLogos.weatherchannel.logoUrl,
    slug: 'the-weather-channel',
  })

  return (
    <>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(videoStructuredData)}</script>
      </Helmet>
      <LiveTemplateDefault
        location={props.location}
        lang="en"
        market="us"
        callsign="WEATHHD"
        title="Watch The Weather Channel live with Fubo"
        networkName="The Weather Channel"
      />
    </>
  )
}
